import validate from "/app/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.7_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@emna_c2a9d855de86d2eba2b8a9536a75a6a9/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.7_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@emna_c2a9d855de86d2eba2b8a9536a75a6a9/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}